import { Card, Col, Row, Statistic, Typography } from 'antd';
import {
  FileTextOutlined,
  TrophyOutlined,
  ClockCircleOutlined,
  FolderOpenOutlined,
} from '@ant-design/icons';
import { useAuthStore } from '../stores/auth';

export default function HomePage() {
  const user = useAuthStore((s) => s.user);
  return (
    <div>
      <Typography.Title level={4}>
        欢迎，{user?.name ?? user?.username}
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        第一阶段仅搭好了骨架与登录闭环，下面的卡片是占位，实际数据会随着后续模块实装而接入。
      </Typography.Paragraph>

      <Row gutter={16}>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="合同总数"
              value="—"
              prefix={<FileTextOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="进行中投标"
              value="—"
              prefix={<TrophyOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="30 天内到期合同"
              value="—"
              prefix={<ClockCircleOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="制式文档"
              value="—"
              prefix={<FolderOpenOutlined />}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
